import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import {
  IS_AUTHENTICATED,
  SET_TENANT_DEFAULT,
} from '@shared/lib/core/interceptors/header-tokens';
import { DeploymentStore } from '@shared/lib/stores/deployment.store';
import { NotificationStore } from '@shared/lib/stores/notification.store';
import { UserStore } from '@shared/lib/stores/user.store';
import { throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

import { environment } from '../../../../../web-app/src/environments/environment';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const userStore = inject(UserStore);
  const notificationStore = inject(NotificationStore);
  const deploymentStore = inject(DeploymentStore);
  const key = userStore?.token()?.token;
  const subscriptionKey = environment.data.gatewayKey;

  req = req.clone({
    setHeaders: {
      'Content-Type': 'application/json; charset=utf-8',
      Accept: 'application/json',
      'ocp-apim-subscription-key': subscriptionKey,
    },
  });

  if (req.context.get(IS_AUTHENTICATED) && req.url.startsWith(environment.data.baseUrl)) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${key}`,
        sub: userStore.userProfile()?.sub ?? ''
      },
    });
  }

  if (req.context.get(SET_TENANT_DEFAULT)) {
    req = req.clone({
      setHeaders: {
        tenantId: deploymentStore.selectedTenantId()?.toString() ?? '',
        deploymentId: deploymentStore.selectedDeploymentId()?.toString() ?? ''
      },
    });
  }

  notificationStore.setLoadingState(req, false);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
        return throwError(error);
      }),
      finalize(() => {
        notificationStore.setLoadingState(req, true);
      })
  );
}
